<template>
  <!-- 反馈入口、文档链接入口、介绍、应用总数、常用应用列表（12个） -->
  <div class="landing-page-box">
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="navbar-box">
        <div style="font-size: 24px;">AI智能体市场</div>
        <div>
          <ul>
            <li>
              <a :href="`/docs`" target="_blank">
              文档
              </a>
            </li>
            <li>
              <el-popover placement="bottom" trigger="hover">
                <img class="wechart" :src="marketInfo && marketInfo.banners && marketInfo.banners.length > 0 && marketInfo.banners[0].imageURL" alt="" />
                <p style="font-size: 12px; margin-bottom: 0px; margin-top:6px; text-align: center">扫一扫，邀你进群交流吧</p>
                <div slot="reference">加入群聊</div>
              </el-popover>
            </li>
            <li>
              <a :href="`/enterprise/login`">
              登录
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <!-- 描述内容 -->
    <div class="store-content">
      <!-- 商店介绍 -->
      <div class="store-desc">
        <div class="desc-title">
          开源应用一键安装
        </div>
         <div class="header_search">
          <el-input
v-model="searchQuery"
placeholder="请输入关键词搜索应用"
class="search_input"
            @keyup.enter.native="handleSearchApp"></el-input>
          <el-button class="search_btn" @click="handleSearchApp" slot="append">
            <svg-icon icon-class="search" style="font-size: 18px; vertical-align: middle"></svg-icon>
          </el-button>
        </div>
        <div class="desc-content-box">
          <div>
            AI智能体市场是一个汇聚了各类开源软件的应用市场，在这里你可以发现和使用各类云原生应用。
            主要包含了各类应用的 Helm Chart、 RAM 模版以及二进制文件，同时还支持信创应用。
            对于 Helm 应用，优化了镜像拉取的问题，使其可以快速部署；
            对于 RAM 模版和信创应用，可以在 Rainbond 中一键安装和升级。
          </div>
        </div>
        <div class="desc-app-start">
          <button id="btn" @click="viewHomePage" class="app-btn">
            发现应用
          </button>
        </div>
        <div class="desc-app-count">
          <div class="app-num">
            <!-- <p class="count-p">{{ total }}</p> -->
            <p class="count-p">500+</p>
            <p class="desc-p">应用数量</p>
          </div>
        </div>

        <div class="app-type-desc-box">
          <div>
            <h2>集成和易用</h2>
            <p>云原生应用市场集成了各类应用，让每个用户都能轻松地发现、选择并通过简单的步骤快速部署应用。</p>
          </div>
          <div>
            <h2>丰富的应用选择</h2>
            <p>这里有来自各个渠道的应用推荐。提供了多种安装方式，包括 Docker 镜像、Helm Chart 以及 RAM 应用模板。</p>
          </div>
          <div>
            <h2>镜像加速</h2>
            <p>云原生应用市场提供了国内网络环境下的镜像加速，使各类应用都可快速部署和访问。</p>
          </div>
          <div>
            <h2>信创市场支持</h2>
            <p>在云原生应用市场中，你可以找到国产化信创所需的应用或中间件，这些均可一键部署和升级。</p>
          </div>
        </div>
      </div>

      <!-- 应用列表 -->
      <div class="store-app-list">
        <div class="store-app-list-title">发现和探索</div>
        <div class="store-app-list-content" v-if="appList.length">
          <div class="app_item" @click="viewAppDetail(item)" v-for="item in appList" :key="item.appKeyID">
            <div class="app_item_top">
              <div class="item_icon">
                <img :src="item.logo || appLogoDef" alt="">
              </div>
              <div class="item_title">
                <div class="item_app_name">
                  <div class="app_name">
                    {{ item.name }}
                  </div>
                  <div class="app_icon">
                    <template>
                      <div class="icon_position">
                        <img v-for="v in item.models" :key="v.templateType" :src="v.templateType == 'helm' ? helmIcon : v.templateType == 'RAM' ? ramIcon : v.templateType == 'docker' ? dockerIcon : fileIcon" :alt="v.templateType == 'helm' ? 'helm' : v.templateType == 'rainbond' ? 'ram' : v.templateType == 'docker' ? 'docker' : 'file'" />
                      </div>
                    </template>
                  </div>
                </div>
                <div class="item_app_tag">
                  <div class="tag_box" v-for="(tag, idx) in item.appClassifications" :key="idx">
                    <div class="tag_icon">
                      <img class="helm_icon" src="../../assets/images/tag-type.svg" alt="" />
                    </div>
                    <div class="tag_name">
                      {{ tag.appClassificationName }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="item_info">
                <div class="app_data">
                  <!-- 安装量 -->
                  <div class="visit">
                    <img :src="appVisit" alt="应用访问数" />
                    <span>{{ item.showCount }}</span>
                  </div>
                  <!-- 浏览量 -->
                  <div class="install">
                    <img :src="appInstall" alt="应用安装数" />
                    <span>{{ item.installCount }}</span>
                  </div>
                </div>
                <div class="app_version">
                  版本:
                  {{ item.maxVersion}}
                </div>
                <div> {{ timmer(item.updateTime) }} </div>
              </div>
            </div>
            <div class="app_item_desc">
              <p>{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <footer>
      <div class="footer">
        AI智能体市场由 <a href="https://www.rainbond.com/feature/app-market">Rainstore</a> 驱动
        &nbsp;&nbsp;&nbsp;京ICP备15028663
      </div>
    </footer>
  </div>
</template>
<script>
import helmIcon from '@/assets/images/helm.svg'
import fileIcon from '@/assets/images/file.svg'
import ramIcon from '@/assets/images/ram.svg'
import dockerIcon from '@/assets/images/docker.svg'
import { getHelmAppListApi } from '@/api/appStore';
import appInstall from '@/assets/images/app_install.svg';
import appVisit from '@/assets/images/app_visit.svg';
import { fetchdayTimes } from '@/utils/timmer';
import {
  getMarketBaseInfoApi
} from '@/api/appStore';
export default {
  name: 'LandingPage',
  data() {
    return {
      appInstall,
      appVisit,
      helmIcon,
      fileIcon,
      ramIcon,
      dockerIcon,
      appList: [],
      total: '',
      appLogoDef: require('../../assets/images/app_icon.png'),
      searchQuery: '',
      marketInfo: {}
    };
  },
  mounted() {
    this.getStoreInfo()
    this.getAppList();
  },
  methods: {
    getStoreInfo() {
      getMarketBaseInfoApi({ marketId: '859a51f9bb3b48b5bfd222e3bef56425' }).then((res) => {
        window.sessionStorage.setItem(
          'storeDomain',
          JSON.stringify(res.domain)
        );
        this.marketInfo = res;
      })
    },
    handleSearchApp() {
      // 如果是详情页,就跳转列表页
      this.$router.push({
        name: 'appstore',
        params: {
          searchQuery: this.searchQuery,
          marketID: 'rainbond'
        }
      });
    },
    // 应用列表
    getAppList() {
      var params = {
        marketId: '859a51f9bb3b48b5bfd222e3bef56425',
        page: 1,
        pageSize: 8,
        usedSort: '1',
        appCount: 'all',
        templateType: 'helm'
      };
      getHelmAppListApi(params)
        .then((res) => {
          this.appList = res.apps || [];
          this.total = res.total
        })
    },
    viewAppDetail(item) {
      this.$router.push({
        path: `/marketplace/apps/${item.appKeyID}`
      });
    },
    timmer(date) {
      return fetchdayTimes(date);
    },
    viewHomePage() {
      this.$router.push({
        name: 'appstore'
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'src/styles/landingPage.scss';
</style>
<style scoped>
button {
  padding: 10px 20px;
  width: 160px;
  text-transform: uppercase;
  border-radius: 8px;
  font-size: 17px;
  font-weight: 500;
  color: #ffffff80;
  text-shadow: none;
  background: transparent;
  box-shadow: transparent;
  border: 1px solid #ffffff80;
  transition: 0.5s ease;
  user-select: none;

}

#btn:hover {
  color: #ffffff;
  background: #002766;
  border: 1px solid #002766;
  text-shadow: 0 0 5px #ffffff, 0 0 10px #ffffff, 0 0 20px #ffffff;
  box-shadow: 0 0 5px #002766, 0 0 20px #002766, 0 0 50px #002766,
    0 0 100px #002766;
}

.wechart {
  width: 140px;
  height: 140px;
}
li{
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/views/landingPage/index.vue